import * as React from "react";
import {VeboxModels} from "../../types/veboxModels";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {RestDataLoader} from "../../dashboard/widgets/unilever/RestDataLoader";
import {DATA_STATE, getUsersAccessesByDay, UsersAccessesByDayState} from "./UsersDashboardContext";


export type CurrentUserDetails = [
    VeboxModels.User,
    (newUser: VeboxModels.User) => void,
    () => void,
    UsersAccessesByDayState
]


const UserDetailsContext = React.createContext<CurrentUserDetails>({} as any);

export const UserDetailsProvider: React.FC = ({children}) => {

    const {userGuid} = useParams();
    const location = useLocation();

    const [usersAccessesByDayState, setAccessesByDayData] = React.useState<UsersAccessesByDayState>({
        userAccessesByDayData: undefined,
        state: DATA_STATE.isLoading
    });

    const navigate = useNavigate();

    const [user, setUser] = React.useState<VeboxModels.User>();

    React.useEffect(() => {
        const u = location.state as VeboxModels.User;
        if (!u || u.guid !== userGuid) {
            reloadCurrentUser();
        } else {
            setUser(u);
        }
    }, [location]);

    const reloadCurrentUser = () => {
        getUserData(userGuid)
            .then((fetchedUser) => {
                if (fetchedUser.guid === userGuid) {
                    setUser(fetchedUser)
                } else {
                    navigate("/", {replace: true})
                }
            })
            .catch(() => {
                navigate("/", {replace: true})
            })
    }

    React.useEffect(() => {
        if (user) {
            getUserLoginInTwoWeeks();
        }
    }, [user]);

    const getUserLoginInTwoWeeks = () => {
        getUsersAccessesByDay({}, `guids=${userGuid}`)
            .then((data) => {
                setAccessesByDayData({
                    userAccessesByDayData: data,
                    state: DATA_STATE.loaded
                });
                return {
                    userAccessesByDayData: data,
                    state: DATA_STATE.loaded
                }
            })
            .catch((err) => {
                setAccessesByDayData({
                    userAccessesByDayData: undefined,
                    state: DATA_STATE.error
                });
                console.error(err)
            })
    }


    return (
        <UserDetailsContext.Provider value={[user, setUser, reloadCurrentUser, usersAccessesByDayState]}>
            {children}
        </UserDetailsContext.Provider>
    )
}

export function useUserDetails() {
    return React.useContext(UserDetailsContext);
}


function getUserData(guid: string): Promise<VeboxModels.User> {
    return new Promise((res, rej) => {
        RestDataLoader.loadData(
            `users/${guid}`,
            {},
            res,
            rej,
        )
    });
}
